import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { common_axios } from "../../../App";
import { toast, ToastContainer } from "react-toastify";

import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";

import {
  Backdrop,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
} from "@mui/material";
import Loader from "../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../helper/helper";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";

export default function ViewTemplates() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectedUserDetailAssign, setSelectedUserDetailAssign] =
    useState(undefined);
  const [Status, setStatus] = useState({
    approveType: 0,
    resellerName: null,
    type: null,
    approveAssignedType: null,
  });

  const fetchUserr = async () => {
    try {
      setOpen(true);

      const res = await common_axios(
        `http://192.168.167.66:5050/admin/templates/v1/listTemplateByUser`
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData(res.data.listOfTemplates);

        setOpen(false);
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      } else {
        setOpen(false);
        await toast.error({
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  useEffect(async () => {
    fetchUserr();
  }, []);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelButtonAssign = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const assignUserModal = async (cell) => {
    cell.row.original["resellerName"] = "";
    await setSelectedUserDetailAssign(cell.row.original);
    await modelButtonAssign.current.click();
  };

  const rejectUserApi = async (e) => {
    e.preventDefault();
    const buttonn = document.getElementById("close_edit");
    try {
      buttonn.click();
      setOpen(true);
      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/template/v1/approve`,
        {
          templateId: selectedUserDetail.id,
          dltId: selectedUserDetail.dltId,
          telemarketerId: selectedUserDetail.telemarketerId,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);

        await toast.success("Template Approved Successfully", {
          theme: "colored",
        });
        fetchUserr();
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };
  const approveUserApi = async (e) => {
    e.preventDefault();
    const buttonn = document.getElementById("close_edit1");
    try {
      buttonn.click();
      setOpen(true);
      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/template/v1/reject`,
        {
          templateId: selectedUserDetailApprove.id,
          rejectReason: selectedUserDetailApprove.rejectReason,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await toast.success("Sender Id removed successfully", {
          theme: "colored",
        });
        fetchUserr();

        setSelectedUserDetailApprove();
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const assignUserApi = async (e) => {
    const buttonn = document.getElementById("close_edit2");
    e.preventDefault();
    try {
      buttonn.click();
      setOpen(true);
      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/template/v1/approve`,
        {
          resellerName: selectedUserDetailAssign.resellerName,
          senderId: selectedUserDetailAssign.senderId,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await toast.success("Sender Id Assigned Successfully", {
          theme: "colored",
        });
        fetchUserr();
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Id",

        accessor: "id",
      },
      {
        Header: "DLT Id",
        accessor: "dltId",
      },
      {
        Header: "Template Name",
        accessor: "templateName",
      },
      {
        Header: "Template Description",
        accessor: "templateDescription",
      },
      {
        Header: "Type",
        accessor: "category",
      },

      {
        Header: "Date",
        accessor: "creationDate",
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.creationDate)}</>;
        // },
      },

      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.approved == 0 ? (
                <>
                  <div className="badge badge_8 bg-warning">Pending</div>
                </>
              ) : cell.row.original.approved == 1 ? (
                <>
                  <div className="badge badge_8 bg-success">Approved</div>
                </>
              ) : (
                <>
                  <div className="badge badge_8 bg-danger">Rejected</div>
                </>
              )}
            </>
          );
        },
      },

      {
        Header: "Account Status",
        Footer: "Account Status",
        accessor: "approved",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.approved == 3 ? (
                <>
                  <div className="badge badge_8 bg-secondary">Blocked</div>
                </>
              ) : cell.row.original.approved == 0 ? (
                <>
                  <div className="badge badge_8 bg-warning">Pending </div>
                </>
              ) : cell.row.original.approved == 1 ? (
                <>
                  <div className="badge badge_8 bg-success">Approved</div>
                </>
              ) : cell.row.original.approved == 2 ? (
                <>
                  <div className="badge badge_8 bg-danger">Rejected</div>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="material-icons opacity-10 size">person</i>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {/* {cell.row.original.approved != 1 && ( */}
              <li
                onClick={() => {
                  // console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  Approve
                </a>
              </li>
              {/* // )} */}
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    // selectedUserDetailApprove["rejectReason"] = "";
                    approveUserModal(cell);
                  }}
                >
                  Reject
                </a>
              </li>
            </ul>
          </div>
        ),

        disableFilters: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetail != undefined && (
        <div>
          <button
            ref={modelButtonReject}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Are you sure to Approve Template
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={rejectUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT Id:
                        </label>
                        {/* {selectedUserDetail.dltId == null ? ( */}
                        <input
                          disabled
                          className="form-control"
                          placeholder="Dlt Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.dltId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              dltId: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetail?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <label for="exampleInputEmail1" className="form-label">
                          Template Body
                        </label>
                        <TextareaAutosize
                          disabled
                          value={selectedUserDetail?.templateDescription}
                          fullWidth
                          minRows={5}
                          className="w-100"
                          placeholder="Message Here"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Approve
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedUserDetailApprove != undefined && (
        <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Are you sure to Reject Template
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <form onSubmit={approveUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT Id:
                        </label>
                        {/* {selectedUserDetail.dltId == null ? ( */}
                        <input
                          disabled
                          className="form-control"
                          placeholder="Dlt Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailApprove?.dltId}
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <label for="exampleInputEmail1" className="form-label">
                          Template Body:
                        </label>
                        <TextareaAutosize
                          disabled
                          value={selectedUserDetailApprove?.templateDescription}
                          fullWidth
                          minRows={5}
                          className="w-100"
                          placeholder="Message Here"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <label for="exampleInputEmail1" className="form-label">
                          Reject Reason:
                        </label>
                        <input
                          required
                          onChange={(e) => {
                            setSelectedUserDetailApprove({
                              ...selectedUserDetailApprove,
                              rejectReason: e.target.value,
                            });
                          }}
                          value={selectedUserDetailApprove?.rejectReason}
                          fullWidth
                          className="w-100"
                          placeholder="Reject reason here"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit1"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-danger">
                      Reject
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedUserDetailAssign != undefined && (
        <div>
          <button
            ref={modelButtonAssign}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop2"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop2"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Are you sure
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={assignUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT Id:
                        </label>
                        {/* {selectedUserDetail.dltId == null ? ( */}
                        <input
                          disabled
                          className="form-control"
                          placeholder="Dlt Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.dltId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              dltId: e.target.value,
                            });
                          }}
                        />
                        {/* ) : (
                          <h6 className="text-capitalize">
                            {selectedUserDetail?.dltId}
                          </h6>
                        )} */}
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailAssign?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Sender Id
                        </label>
                        <input
                          disabled
                          required
                          className="form-control"
                          placeholder="Sender Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.senderId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              senderId: e.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Assign Sender Id to:
                        </label>
                        <Autocomplete
                          fullWidth
                          required
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={data1}
                          // value={Status.resellerName}
                          onChange={(e, val) => {
                            setSelectedUserDetailAssign({
                              ...selectedUserDetailAssign,
                              resellerName: val,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              size="small"
                              label="Select Reseller"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit2"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Assign
                    </button>
                  </div>
                </form>

                {/* <form onSubmit={assignUserApi}>
                  <div className="modal-body">
                    <div className="mt-4">
                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Sender Id:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.senderId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">DltId:</h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.dltId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Category:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.category}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Assign Sender Id to:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <Autocomplete
                            required
                            disablePortal
                            id="combo-box-demo"
                            options={data1}
                            sx={{ width: 200 }}
                            // value={Status.resellerName}
                            onChange={(e, val) => {
                              setSelectedUserDetailAssign({
                                ...selectedUserDetailAssign,
                                resellerName: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Select Reseller"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Assign
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <i className="material-icons opacity-10">person</i>
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                View Templates
              </p>
            </div>
          </div>

          <div className="card-body">
            {data.length > 0 ? (
              <>
                <div className="d-flex justify-content-between my-3">
                  <div className="d-flex justify-content-between">
                    <select
                      value={pageSize}
                      className="dropdown"
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                      }}
                    >
                      {[10, 25, 50].map((value, i) => {
                        return (
                          <option
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                            value={value}
                            key={value}
                          >
                            Show {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="d-flex align-items-center">
                    <span className="d-block">Search</span>
                    <input
                      className="form-control ms-2"
                      type="text"
                      value={globalSearchValue || ""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setGlobalSearchValue(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className="text-left"
                                  className={
                                  cell.column.Header == "Id"
                                                            ? "text-end"
                                                            : cell.column
                                                                .Header ==
                                                                "Status" ||
                                                                cell.column
                                                                .Header ==
                                                                "Action" ||
                                                                cell.column.Header ==
                                                                "Unicode"
                                                            ? "text-center"
                                                            : "text-start"
                                                        }
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span>

                    <span>
                      | Go to Page :
                      <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(pageNumber);
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div>

                  <div>
                    <button
                      className="btn btn_primary m-0"
                      type="button"
                      disabled={!canPreviousPage}
                      onClick={() => {
                        previousPage();
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary m-0"
                      type="button"
                      disabled={!canNextPage}
                      onClick={() => {
                        nextPage();
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">
                <p>No Data Available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
